module.exports = __webpack_public_path__ + "img/010-slovenia.8ebd49ef.svg";